{
  "page": {
    "title": "Avvisi snipe",
    "subtitle": "Ricevi messaggi diretti su Discord quando oggetti, mascotte o WoW Token che stai monitorando appaiono all'asta sotto il tuo prezzo obiettivo."
  },
  "discordRequired": {
    "title": "Discord richiesto",
    "description": "Devi collegare il tuo account Discord prima di poter configurare gli avvisi snipe. Gli avvisi vengono inviati come messaggi diretti Discord.",
    "linkButton": "Vai alle impostazioni per collegare Discord"
  },
  "loading": "Caricamento...",
  "notifications": {
    "title": "Notifiche snipe",
    "description": "Ricevi avvisi quando oggetti o mascotte monitorati vengono trovati sotto il tuo prezzo obiettivo."
  },
  "alertStyle": {
    "title": "Stile avviso",
    "subtitle": "Scegli come vengono visualizzate le notifiche Discord.",
    "compact": "Compatto",
    "compactDescription": "Embed solo testo, senza miniature. Più avvisi per messaggio.",
    "detailed": "Dettagliato",
    "detailedDescription": "Embed ricchi con miniature degli oggetti. Un embed per oggetto."
  },
  "cooldown": {
    "title": "Tempo di ricarica avvisi",
    "subtitle": "Quanti cicli di aggiornamento della casa d'aste (circa 1 ora ciascuno) saltare prima di ripetere un avviso per la stessa asta. 0 = avvisa a ogni aggiornamento.",
    "cycles": "cicli",
    "save": "Salva",
    "saving": "Salvataggio..."
  },
  "realms": {
    "title": "Regni da monitorare",
    "subtitle": "Seleziona i regni {{region}} da monitorare per opportunità di snipe.",
    "placeholder": "Seleziona i regni da monitorare",
    "removeRussian": "Rimuovi tutti i regni russi",
    "saveButton": "Salva regni",
    "savingButton": "Salvataggio..."
  },
  "addEdit": {
    "addTitle": "Aggiungi snipe {{type}}",
    "editTitle": "Modifica snipe {{type}}",
    "typeLabel": "Tipo",
    "typeItem": "Oggetto",
    "typePet": "Mascotte",
    "typeToken": "Token",
    "typeIlvl": "ilvl",
    "itemNameLabel": "Nome oggetto",
    "petNameLabel": "Nome mascotta o ID",
    "tokenLabel": "Token",
    "searchPlaceholder": "Cerca un oggetto...",
    "petPlaceholder": "Inserisci ID mascotta (es. 3390) o cerca per nome...",
    "priceLabelMin": "1g",
    "priceLabelMax": "9.999.999g 99s",
    "targetPriceLabel": "Prezzo obiettivo",
    "pricePlaceholder": "es. 500g o 500g 50s",
    "ilvlMinLabel": "ilvl min",
    "ilvlMaxLabel": "ilvl max",
    "optional": "(opz)",
    "sockets": "Incastonature",
    "secondaryStats": "Statistiche Secondarie",
    "secondaryStatsHint": "(opzionale, seleziona fino a 2)",
    "statCrit": "Critico",
    "statHaste": "Rapidità",
    "statVersatility": "Versatilità",
    "statMastery": "Maestria",
    "noItemsFound": "Nessun oggetto trovato",
    "noPetsFound": "Nessuna mascotta trovata",
    "anyItem": "Qualsiasi oggetto",
    "addButton": "Aggiungi {{type}}",
    "updateButton": "Aggiorna {{type}}",
    "addTokenButton": "Aggiungi avviso Token",
    "updateTokenButton": "Aggiorna avviso Token",
    "cancelEdit": "Annulla modifica",
    "remove": "Rimuovi",
    "nounItem": "oggetto",
    "nounPet": "mascotte",
    "categoryLabel": "Categoria",
    "statSpeed": "Velocità",
    "statLeech": "Risucchio",
    "statAvoidance": "Elusione"
  },
  "importExport": {
    "importButton": "Importa JSON {{label}}",
    "importingButton": "Importazione...",
    "exportIlvlButton": "Esporta JSON oggetti ilvl",
    "exportButton": "Esporta JSON {{label}}",
    "clearAllButton": "Cancella tutti {{label}} ({{count}})",
    "pasteHint": "Tip: Premi Ctrl+V (o Cmd+V su Mac) ovunque in questa pagina per incollare e importare un file JSON direttamente.",
    "clearAllTitle": "Cancella tutto: {{label}}",
    "clearAllConfirmButton": "Cancella tutto"
  },
  "tabs": {
    "items": "Oggetti",
    "ilvlItems": "Oggetti ilvl",
    "pets": "Mascotte",
    "token": "WoW Token"
  },
  "table": {
    "filterPlaceholder": "Filtra per nome oggetto o ID...",
    "countAll": "{{count}} regola/e ilvl",
    "countFiltered": "{{filtered}} di {{total}} regole ilvl",
    "countItems": "{{count}} {{noun}}",
    "countItemsFiltered": "{{filtered}} di {{total}} {{noun}}",
    "colItems": "Oggetti",
    "colIlvl": "ilvl",
    "colStats": "Statistiche",
    "colBuyout": "Acquisto immediato",
    "colActions": "Azioni",
    "colTargetPrice": "Prezzo obiettivo",
    "editButton": "Modifica",
    "duplicateButton": "Duplica",
    "deleteButton": "Elimina",
    "emptyState": "{{hint}}",
    "emptyHintItems": "Cerca un oggetto qui sopra o importa un file JSON per iniziare.",
    "emptyHintPets": "Inserisci un ID mascotte qui sopra o importa un file JSON per iniziare.",
    "emptyHintToken": "Imposta un prezzo obiettivo qui sopra per ricevere una notifica quando il gettone WoW scende sotto quel valore.",
    "emptyHintIlvl": "Imposta i limiti di livello oggetto qui sopra o importa un file JSON per iniziare.",
    "nounItems": "oggetto/i",
    "nounPets": "mascotte",
    "nounToken": "avviso token",
    "nounIlvl": "regola/e ilvl",
    "loadingName": "Caricamento...",
    "colCategory": "Categoria",
    "percentLoaded": "{{percent}}% caricato",
    "editPrice": "Modifica prezzo",
    "inlineEditHint": "Clicca per modificare — Invio salva, Esc annulla"
  },
  "personalConfig": {
    "title": "Configurazione filtri personale",
    "subtitle": "Regola i filtri qui sotto per impostare le preferenze predefinite. Verranno applicati automaticamente quando usi gli strumenti d'asta.",
    "tip": "💡 Suggerimento: imposta i filtri come desideri, poi clicca su \"Salva come predefiniti\" per renderli permanenti.",
    "livePreviewTitle": "Anteprima filtri in tempo reale",
    "livePreviewSubtitle": "Questi sono i filtri effettivi dello strumento d'asta. Imposta i tuoi predefiniti secondo necessità:",
    "saveButton": "Salva filtri predefiniti",
    "resetToSavedButton": "🔄 Ripristina ai miei predefiniti salvati",
    "resetToSystemButton": "⚙️ Ripristina ai predefiniti di sistema",
    "needHelp": "Hai bisogno di aiuto con la configurazione? Unisciti al nostro Discord",
    "dashboardSection": "Filtro Opportunità della Dashboard",
    "dashboardSectionSubtitle": "Imposta l'intervallo del prezzo di acquisto immediato per gli oggetti mostrati nel widget Migliori Opportunità della dashboard.",
    "dashboardBuyoutMin": "Acquisto Min. (Oro)",
    "dashboardBuyoutMax": "Acquisto Max. (Oro)",
    "dashboardBuyoutMaxHint": "Imposta a 0 per nessun massimo",
    "dashboardSaveButton": "Salva configurazione dashboard",
    "itemMatchingSection": "Impostazioni chiave articolo",
    "itemMatchingSectionSubtitle": "Controlla come le varianti degli articoli vengono abbinate tra i regni nel calcolo delle opportunità.",
    "ignoreStatsBeforeExpansion": "Ignora le statistiche secondarie prima di questa espansione",
    "ignoreStatsBeforeExpansionHint": "Gli articoli delle espansioni precedenti a quella selezionata verranno trattati come identici indipendentemente dall'affisso della statistica secondaria. Utile per articoli di espansioni vecchie dove le differenze di statistiche non influenzano il valore di rivendita.",
    "ignoreStatsNone": "Nessuno (disabilitato)",
    "itemMatchingSaveButton": "Salva impostazioni articolo"
  },
  "inventoryAnalysis": {
    "premiumRequired": "Hai bisogno di un abbonamento premium attivo per utilizzare lo strumento!",
    "subscriptionRequired": "Hai bisogno di un abbonamento attivo per utilizzare lo strumento!",
    "pasteCSVFirst": "Incolla prima i dati CSV del tuo inventario.",
    "csvPasted": "CSV inventario incollato.",
    "pasteHint": "Tip: Premi Ctrl+V (o Cmd+V su Mac) ovunque in questa pagina per incollare il tuo CSV dell'inventario direttamente.",
    "noValidItems": "Nessun oggetto valido trovato nei dati CSV. Controlla il formato.",
    "analysisComplete": "Analisi completata! Trovate {{opportunities}} opportunità di vendita per {{items}} oggetti dell'inventario.",
    "analysisFailed": "Analisi dell'inventario non riuscita. Riprova.",
    "title": "Analisi inventario",
    "description": "Incolla il tuo export CSV dell'inventario di gioco qui sotto. Analizzeremo ogni oggetto su tutti i regni disponibili per trovare le migliori opportunità di vendita.",
    "addonInstall": "Installa l'addon da",
    "addonInstallHere": "qui",
    "csvFormatTitle": "Formato CSV atteso",
    "csvFormatNote": "Delimitato da punto e virgola. I BonusID sono separati da due punti (es.",
    "csvModifiersNote": "). I modificatori usano",
    "csvModifiersFormat": "tipo=valore",
    "csvModifiersExample": "formato (es.",
    "sellingRealmsTitle": "Regni di vendita per l'inventario",
    "suggestedDropships": "Dropship suggeriti",
    "inventoryDataLabel": "Dati inventario",
    "itemsDetected": "{{count}} oggetto rilevato",
    "itemsDetectedPlural": "{{count}} oggetti rilevati",
    "uploadFile": "Carica file",
    "analyzeButton": "Analizza {{count}} oggetti",
    "analyzeInventoryButton": "Analizza inventario",
    "clearButton": "Cancella",
    "backToInput": "Torna all'input inventario",
    "noOpportunities": "Nessuna opportunità di vendita trovata per gli oggetti del tuo inventario.",
    "noOpportunitiesReason": "Questo può accadere se gli oggetti non hanno dati di mercato TSM o non sono scambiabili.",
    "tryAgain": "Riprova",
    "exportCSV": "Esporta per FlipQueue"
  },
  "realmConfig": {
    "setupGuideLink": "Clicca qui per la guida alla configurazione dello strumento",
    "selectRegion": "Seleziona la regione corrente",
    "updateBuyingRealms": "Aggiorna i regni di acquisto per {{region}} ({{selected}} di {{total}})",
    "updateSellingRealms": "Aggiorna i regni di vendita per {{region}} ({{selected}} di {{max}})",
    "sellingRealmLimitTooltip": "Come abbonato con un abbonamento {{type}} puoi selezionare solo {{max}} regni di vendita.",
    "addAllToBuying": "Aggiungi tutti i regni ai regni di acquisto",
    "removeAllFromBuying": "Rimuovi tutti i regni dai regni di acquisto",
    "removeRussianFromBuying": "Rimuovi tutti i regni russi dai regni di acquisto",
    "addAllToSelling": "Aggiungi tutti i regni ai regni di vendita",
    "removeAllFromSelling": "Rimuovi tutti i regni dai regni di vendita",
    "removeRussianFromSelling": "Rimuovi tutti i regni russi dai regni di vendita",
    "wowAccountsTitle": "Account WoW",
    "addAccount": "Aggiungi account",
    "accountNamePlaceholder": "Nome account (es. WoW2)",
    "accountNameRequired": "Il nome dell'account è obbligatorio",
    "addAccountFailed": "Impossibile aggiungere l'account",
    "deleteAccountDefault": "Impossibile eliminare l'account predefinito",
    "deleteAccountConfirm": "Sei sicuro? Questo account verrà rimosso da tutte le assegnazioni di regni.",
    "deleteAccountFailed": "Impossibile eliminare l'account",
    "updateAccountFailed": "Impossibile aggiornare il nome dell'account",
    "assignRealmsLabel": "Assegna regni agli account (un regno può essere in più account):",
    "selectAll": "Seleziona tutto",
    "deselectAll": "Deseleziona tutto",
    "noRealmsSelected": "Nessun regno selezionato",
    "addMoreAccounts": "Aggiungi altri account per assegnare regni a diversi account WoW.",
    "saveButton": "Salva tutti i dati",
    "missingAccountsError": "Assegna almeno un account a ogni regno. Mancanti: {{realms}}",
    "discordQuestion": "Hai ancora domande? Unisciti al nostro Discord",
    "navigateToFlippingTool": "Flipping Tool",
    "navigateToDropshipTool": "Dropship Tool",
    "navigateToHousingTool": "Housing Tool",
    "navigateToTSMListGenerator": "Generatore di liste TSM",
    "saveButtonDirty": "Salva modifiche •",
    "saveSettingsFailed": "Impossibile salvare le impostazioni",
    "unsavedTitle": "Modifiche non salvate",
    "unsavedLeaveMessage": "Hai impostazioni dei reami non salvate. Se lasci questa pagina, le modifiche andranno perse.",
    "unsavedLeaveConfirm": "Esci senza salvare",
    "unsavedStay": "Rimani sulla pagina",
    "saveBeforeNavTitle": "Salvare le modifiche?",
    "saveBeforeNavMessage": "La tua selezione dei reami contiene modifiche non salvate. Salvale affinché lo strumento utilizzi le nuove impostazioni.",
    "saveAndContinue": "Salva e continua",
    "deleteAccountTitle": "Elimina account WoW",
    "deleteAccountMessage": "Eliminare l'account \"{{name}}\"? Verrà rimosso da tutte le assegnazioni dei reami.",
    "deleteAccountConfirmButton": "Elimina",
    "renameAccountAria": "Rinomina l'account {{name}}",
    "deleteAccountAria": "Elimina l'account {{name}}",
    "confirmRenameAria": "Salva il nome dell'account",
    "cancelRenameAria": "Annulla la rinomina",
    "confirmAddAria": "Aggiungi account",
    "cancelAddAria": "Annulla l'aggiunta"
  },
  "tsmProfile": {
    "title": "Guida alla configurazione del profilo TSM",
    "realmPriceAnalysis": "Analisi prezzi del regno",
    "minimumPriceOperation": "Operazione prezzo minimo",
    "maximumPriceOperation": "Operazione prezzo massimo",
    "normalPriceOperation": "Operazione prezzo normale",
    "copyButton": "Copia",
    "copiedSuccess": "Operazione di prezzo TSM {{operation}} copiata negli appunti!",
    "copyFailed": "Copia negli appunti non riuscita"
  },
  "tsmListGenerator": {
    "subscriptionRequired": "Hai bisogno di un abbonamento attivo per utilizzare lo strumento!",
    "watchVideoGuide": "Guarda la guida video",
    "copyTSMString": "Copia la stringa TSM",
    "copyTSMFailed": "Impossibile copiare la stringa TSM negli appunti",
    "videoGuideTitle": "Guida video del generatore di liste TSM",
    "emptyTitle": "Nessun dato d'asta trovato",
    "emptyDescription": "Nessun dato d'asta corrisponde ai reami configurati. Controlla la configurazione dei reami o riprova dopo il prossimo aggiornamento della casa d'aste.",
    "emptyConfigureButton": "Configura reami",
    "emptyRetryButton": "Riprova"
  },
  "realmStats": {
    "subscriptionRequired": "Hai bisogno di un abbonamento attivo per utilizzare lo strumento!",
    "overallStatistics": "Statistiche generali",
    "realmPriceAnalysis": "Analisi prezzi del regno",
    "watchVideoGuide": "Guarda la guida video",
    "noData": "Nessun dato di regno disponibile",
    "legend": "Legenda",
    "legendCheap": "Piuttosto economico (<{{ratio}})",
    "legendNormal": "Intorno alla norma ({{min}}-{{max}})",
    "legendExpensive": "Significativamente costoso (>{{ratio}})",
    "tooltipCheap": "Ciò significa che gli oggetti sono generalmente più vicini alla media di vendita regionale in termini di prezzo. Acquistare qui è piuttosto economico, ma non è così vantaggioso per vendere.",
    "tooltipNormal": "Ciò significa che gli oggetti sono misti rispetto alla media di vendita regionale. Può essere vantaggioso sia per acquistare che per vendere.",
    "tooltipExpensive": "Ciò significa che gli oggetti sono generalmente ben al di sopra della media di vendita regionale. È piuttosto costoso acquistare qui, ma potrebbe essere vantaggioso per vendere.",
    "colRealmName": "Nome regno",
    "colPopulation": "Popolazione",
    "colAuctions": "Aste",
    "colPriceRatio": "Rapporto prezzo",
    "colCheaper": "Più economico",
    "colExpensive": "Più costoso",
    "colPercentCheaper": "% Più economico",
    "colPercentExpensive": "% Più costoso",
    "colPercentEqual": "% Uguale",
    "totalRealms": "Regni totali",
    "totalAuctions": "Aste totali",
    "avgPriceRatio": "Rapporto prezzo medio",
    "cheaperThanRegion": "Più economico della regione",
    "totalAuctionsHistory": "Storico aste totali",
    "avgPriceRatioHistory": "Storico rapporto prezzo medio",
    "percentCheaperHistory": "Storico % più economico",
    "auctionsHistory": "{{realm}} - Storico aste",
    "priceRatioHistory": "{{realm}} - Storico rapporto prezzo",
    "cheaperCountHistory": "{{realm}} - Storico conteggio più economico",
    "expensiveCountHistory": "{{realm}} - Storico conteggio più costoso",
    "percentCheaperRealm": "{{realm}} - Storico % più economico",
    "percentExpensiveRealm": "{{realm}} - Storico % più costoso",
    "percentEqualRealm": "{{realm}} - Storico % uguale",
    "videoTitle": "Guida video dello strumento statistiche regno"
  },
  "tsmDataTable": {
    "colItemName": "Nome oggetto",
    "colCategory": "Categoria",
    "colExpansion": "Espansione",
    "colSellRate": "Tasso di vendita",
    "colSaleAvg": "Media di vendita",
    "colRegionMarketValue": "Valore di mercato regionale",
    "colRegionHistorical": "Storico regionale",
    "clickToCopy": "Clicca per copiare: {{name}}",
    "tooltipSaleAvg": "Prezzo medio a cui un oggetto è stato venduto negli ultimi 60 giorni",
    "tooltipMarketValue": "Prezzo medio a cui un oggetto è stato messo in vendita negli ultimi 14 giorni su tutti i regni della tua regione",
    "tooltipHistorical": "Prezzo medio a cui un oggetto è stato messo in vendita negli ultimi 60 giorni su tutti i regni della tua regione"
  },
  "import": {
    "confirmTitle": "Conferma importazione",
    "confirmMessage": "Importare {{count}} voci nella lista {{tab}}?",
    "confirmMessageCategory": "Importare {{count}} voci nella lista {{tab}} (categoria: {{category}})?",
    "confirmButton": "Importa"
  }
}
